import React from 'react';
import { Link } from 'react-router-dom';

const LogoutPage = () => {
  return (
    <div className="logout-page">
      {/* Hero Section - Logout Confirmation */}
      <section className="py-20" style={{
        background: `linear-gradient(to top, #FFC000 0%, #FFFFFF 3%, #FFFFFF 97%, #FFC000 100%)`
      }}>
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            {/* Main Message */}
            <h1 className="text-5xl md:text-6xl font-bold mb-6 text-gray-900 dark:text-white">
              You've been successfully <span style={{ color: '#FFC000' }}>Logged Out</span>
            </h1>

            {/* Subtext */}
            <p className="text-xl md:text-2xl mb-8 text-[#0E3056] dark:text-gray-300">
              Thank you for using AgentNexus. Your session has been securely ended.
            </p>

            {/* Call-to-Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              {/* Sign In Again - Yellow Button */}
              <Link
                to="/login"
                style={{
                  backgroundColor: '#FFC000',
                  color: '#0E3056',
                  padding: '1rem 2rem',
                  borderRadius: '0.5rem',
                  fontWeight: '600',
                  transition: 'all 0.2s'
                }}
                className="hover:opacity-90 inline-block"
              >
                Sign In Again
              </Link>

              {/* Return to Home - Outlined Button */}
              <Link
                to="/"
                style={{
                  border: '2px solid #FFC000',
                  color: '#FFC000',
                  padding: '1rem 2rem',
                  borderRadius: '0.5rem',
                  fontWeight: '600',
                  transition: 'all 0.2s'
                }}
                className="hover:bg-[#FFC000] hover:text-[#0E3056] inline-block dark:hover:text-[#0E3056]"
              >
                Return to Home
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Information Section */}
      <section className="py-16 bg-white dark:bg-gray-800">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold mb-8 text-center text-gray-900 dark:text-white">
              Session Security
            </h2>

            <div className="grid md:grid-cols-3 gap-8">
              {/* Session Ended */}
              <div className="text-center">
                <div className="mb-4 flex justify-center">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(255, 192, 0, 0.1)' }}>
                    <svg className="w-6 h-6" style={{ color: '#FFC000' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                  </div>
                </div>
                <h3 className="text-lg font-semibold mb-2 text-gray-900 dark:text-white">
                  Session Ended
                </h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm">
                  Your session has been terminated and all authentication tokens cleared.
                </p>
              </div>

              {/* Data Protected */}
              <div className="text-center">
                <div className="mb-4 flex justify-center">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(255, 192, 0, 0.1)' }}>
                    <svg className="w-6 h-6" style={{ color: '#FFC000' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                  </div>
                </div>
                <h3 className="text-lg font-semibold mb-2 text-gray-900 dark:text-white">
                  Data Protected
                </h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm">
                  All your data remains secure and protected in our HIPAA-compliant systems.
                </p>
              </div>

              {/* Ready to Return */}
              <div className="text-center">
                <div className="mb-4 flex justify-center">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(255, 192, 0, 0.1)' }}>
                    <svg className="w-6 h-6" style={{ color: '#FFC000' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </div>
                </div>
                <h3 className="text-lg font-semibold mb-2 text-gray-900 dark:text-white">
                  Ready to Return
                </h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm">
                  Sign in anytime to access your AgentNexus platform and features.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Support Section */}
      <section className="py-16 bg-gray-50 dark:bg-gray-900">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">
              Need Assistance?
            </h2>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              Our support team is here to help you with any questions or issues.
            </p>
            <Link
              to="/contact"
              style={{
                color: '#FFC000',
                fontWeight: '600',
                transition: 'opacity 0.2s'
              }}
              className="hover:opacity-80 inline-flex items-center"
            >
              Contact Support
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LogoutPage;
